import React, { Component } from "react";
import { connect } from "react-redux";
import HistoryRender from "./children/HistoryRender";
import { requsetGetHistoryiles, requsetDelHistoryiles } from "../../../../api/apiHistory";
import { GAPersonalHistoryPageDisplay } from "../../../../ga/personalCenter";
import Utils from "../../../../../../utils";
import BasicModal from "../../../../../../components/basicModal/BasicModal";
import "../../../../assets/history.scss";
import { withTranslation } from "react-i18next";
import actions from "../../../../redux/action";
class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      selectAll: false,
      selectGuidList: [], //批量删除选中的文件
      files: [],
      job_ids: [],
      //删除确认弹窗信息
      basicModalObj: {
        visible: false,
        content: this.props.t("deleteTips"),
        onCancel: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
        },
        onOk: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
          this.handleDeleteFn();
        },
      },
    };
  }
  componentDidMount() {
    this.handleGetHistoryiles();
  }
  //获取文件
  handleGetHistoryiles = () => {
    requsetGetHistoryiles()
      .then(res => {
        if (res.code === 200) {
          this.props.onHistoryObjChange(res.data.history_files ? res.data.history_files : []);
          this.setState({
            selectGuidList: [],
            selectAll: false,
          });
          GAPersonalHistoryPageDisplay(res.data.history_files ? res.data.history_files.length : 0);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  //删除切换
  editingChange = val => {
    this.setState({
      isEditing: val,
      selectGuidList: [],
      selectAll: false,
    });
  };
  //全选
  handleSelectAll = e => {
    const files = this.props.historyObj;
    let selectGuidList = [];
    if (e.target.checked) {
      selectGuidList = files.map(item => item.job_id);
    } else {
      selectGuidList = [];
    }
    this.setState({
      selectAll: e.target.checked,
      selectGuidList: selectGuidList,
    });
  };
  //批量删除时选择文件
  handleSelectClick = file => {
    let { selectGuidList } = this.state;
    const files = this.props.historyObj;
    if (selectGuidList.some(item => item == file.job_id)) {
      selectGuidList = selectGuidList.filter(item => item != file.job_id);
    } else {
      selectGuidList.push(file.job_id);
    }
    this.setState({
      selectGuidList: selectGuidList,
    });
    if (selectGuidList.length == 0) {
      this.setState({
        selectAll: false,
      });
    } else if (files.length == selectGuidList.length) {
      this.setState({
        selectAll: true,
      });
    }
  };
  handleDelete = file => {
    let { selectGuidList } = this.state;
    if (file && file.job_id) {
      this.setState({
        job_ids: [file.job_id],
      });
    } else {
      if (selectGuidList <= 0) return;
      this.setState({
        job_ids: selectGuidList,
      });
    }
    const basicModalObj = { ...this.state.basicModalObj };
    basicModalObj.visible = true;
    this.setState({
      basicModalObj,
    });
  };
  //删除
  handleDeleteFn = () => {
    requsetDelHistoryiles({ body: JSON.stringify({ job_ids: this.state.job_ids }) })
      .then(res => {
        if (res.code === 200) {
          this.handleGetHistoryiles();
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  //下载
  handleDownloadClick = item => {
    Utils.downloadFile(item, item.file_name);
  };
  render() {
    return (
      <>
        <HistoryRender
          subscription={this.props.subscription}
          isEditing={this.state.isEditing}
          selectAll={this.state.selectAll}
          editingChange={this.editingChange}
          files={this.props.historyObj}
          selectGuidList={this.state.selectGuidList}
          handleSelectAll={this.handleSelectAll}
          handleSelectClick={this.handleSelectClick}
          handleDelete={this.handleDelete}
          handleDownloadClick={this.handleDownloadClick}
        />
        <BasicModal {...this.state.basicModalObj} />
      </>
    );
  }
}

const mapStateToPropos = state => ({
  subscription: state.account.subscription,
  historyObj: state.account.historyObj,
});
const mapDispatchToProps = dispatch => ({
  onHistoryObjChange: historyObj => dispatch(actions.onHistoryObjChange(historyObj)),
});
export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["personalCenterHistory", "common"])(History));
